import { z } from 'zod'

type Translate = (key: string) => string

const MAX_AGE_YEARS = 120

// Terms of Service set 16 as the minimum age for an account. Birthday stays
// optional, so this only checks the ones we are actually given.
const MIN_AGE_YEARS = 16

export function createProfileSchema(t: Translate) {
  const today = new Date()
  const minBirthday = new Date(today.getFullYear() - MAX_AGE_YEARS, 0, 1)
  const latestBirthday = new Date(
    today.getFullYear() - MIN_AGE_YEARS,
    today.getMonth(),
    today.getDate(),
  )

  return z.object({
    firstName: z
      .string()
      .min(1, { message: t('createProfile.errors.firstNameRequired') })
      .max(50, { message: t('createProfile.errors.firstNameTooLong') }),
    lastName: z
      .string()
      .max(50, { message: t('createProfile.errors.lastNameTooLong') })
      .optional(),
    birthday: z
      .date()
      .max(today, { message: t('createProfile.errors.birthdayFuture') })
      .min(minBirthday, { message: t('createProfile.errors.birthdayInvalid') })
      .refine((value) => value <= latestBirthday, {
        message: t('createProfile.errors.birthdayTooYoung'),
      })
      .nullable()
      .optional(),
    referredByCode: z
      .string()
      .refine(
        (v) => !v || /^[A-Z0-9]{6}$/.test(v.trim().toUpperCase()),
        { message: t('createProfile.errors.inviteCodeInvalid') },
      )
      .optional(),
  })
}
